/** Net profit by month as bars, one series (so no legend); a loss month is marked by colour. Hover or focus a bar for its figures. */
import { useState } from "react";
import type { FinanceSummary } from "@sable/api-contract";
import { t } from "../i18n/index.ts";
import { money, monthLabel } from "../lib/format.ts";

export function MonthBars({ data }: { data: FinanceSummary }) {
  const [hover, setHover] = useState<number | null>(null);
  const max = Math.max(1, ...data.months.map((m) => Math.abs(m.netProfitMinor)));
  return (
    <div className="chart">
      <div className="bars">
        {data.months.map((m, i) => {
          const h = Math.max(1, Math.round((Math.abs(m.netProfitMinor) / max) * 100));
          const label = `${monthLabel(m.month)}: ${money(m.netProfitMinor, data.currency)}`;
          return (
            <div key={m.month} className="bar" tabIndex={0} aria-label={label}
              onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(null)}
              onFocus={() => setHover(i)} onBlur={() => setHover(null)}>
              {hover === i && (
                <div className="tip" role="tooltip">
                  <strong>{monthLabel(m.month)}</strong>
                  <span>{t("finance.net")}: {money(m.netProfitMinor, data.currency)}</span>
                  <span>{t("finance.revenue")}: {money(m.grossRevenueMinor, data.currency)}</span>
                  <span>{t("finance.units")}: {m.unitsSold}</span>
                </div>
              )}
              <div className={`fill h${h}${m.netProfitMinor < 0 ? " neg" : ""}`} />
              <span className="tick">{monthLabel(m.month).split(" ")[0]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
